export default "__VITE_ASSET__8qHCeGCe__"